import { render } from "./NodeChatMain.vue?vue&type=template&id=64532f62"
import script from "./NodeChatMain.vue?vue&type=script&lang=js"
export * from "./NodeChatMain.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"NodeChatMain.vue"]])

export default __exports__